import "react";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/loadingRing.svg
var n = (n) => /* @__PURE__ */ t("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	...n,
	children: [/* @__PURE__ */ e("g", {
		clipPath: "url(#clip0_27462_33628)",
		children: /* @__PURE__ */ e("path", {
			stroke: "#fff",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.667,
			d: "M1.667 10A8.333 8.333 0 1 0 10 1.667"
		})
	}), /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", {
		id: "clip0_27462_33628",
		children: /* @__PURE__ */ e("rect", {
			width: 20,
			height: 20,
			fill: "#fff"
		})
	}) })]
});
//#endregion
export { n as default };
